/* eslint-disable class-methods-use-this */
import Cookies from "js-cookie";

import { COOKIE_DOMAIN, SECURE_COOKIE } from "./constants";

const ONE_YEAR = 365;

class ZeplinCookies {
    constructor() {
        // SameSite=None is not set when the cookie is not secure
        const sameSite = SECURE_COOKIE ? "none" : "lax";

        Cookies.defaults = {
            domain: COOKIE_DOMAIN,
            expires: ONE_YEAR,
            secure: SECURE_COOKIE,
            sameSite
        };
    }

    has(key) {
        return Cookies.get(key) !== undefined;
    }

    get(key) {
        return Cookies.get(key);
    }

    set(key, value, attributes = {}) {
        Cookies.set(key, value, attributes);
    }

    remove(key) {
        Cookies.remove(key);
    }
}

const zplCookies = new ZeplinCookies();
// TODO: remove cookie upgrade logic after a reasonable amount of time
const userTokenUpgraded = localStorage.getItem("userTokenUpgraded");
const userToken = zplCookies.get("userToken");
if (!userTokenUpgraded && userToken) {
    zplCookies.set("userToken", userToken);
    localStorage.setItem("userTokenUpgraded", "true");
}

export default zplCookies;
